import { render } from "./LanguagesTable.vue?vue&type=template&id=09c58b1e"
import script from "./LanguagesTable.vue?vue&type=script&lang=js"
export * from "./LanguagesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__